module.exports = __webpack_public_path__ + "static/media/store-icon.cbd5b121.svg";